<template>
  <div class="wrapper">
    <div class="wrapper-body">
      <div class="wrapper-inner">
        <img class="logo" src="https://cdn.parcelex.com.br/assets/v2/website/parcelex-logo-color-dark.svg">
        <h2 class="main-title">
          Olá, <span class="text-primary-400">{{ name | capitalize({ first: true }) }}</span>
        </h2>
        <p class="lead">
          Veja o que falta para concluir sua compra:
        </p>
        <div class="step-list">
          <div class="step-list-item">
            <div class="step-list-icon">
              <AssetV3 dir="icons" name="blue-outline-identification.svg"/>
            </div>
            <div class="step-list-text">
              {{ bypassDocuments ? 'Envio da selfie' : 'Envio de documento e selfie' }}
            </div>
          </div>

          <div class="step-list-item" v-if="downPayment && !downPaymentPaid">
            <div class="step-list-icon">
              <AssetV3 dir="icons" name="blue-outline-currency-dollar.svg"/>
            </div>
            <div class="step-list-text">
              Pagamento da entrada
            </div>
          </div>
        </div>

      </div>
    </div>

    <a @click="handleNextStep" class="button-primary">
      Continuar
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import AssetV3 from '@/components/common/AssetV3.vue';
import StringMixing from '@/mixins/string';

export default {
  name: 'onboarding-missing-steps',
  mixins: [StringMixing],
  components: {
    AssetV3,
  },
  computed: {
    ...mapState('onboarding', [
      'name',
      'downPayment',
      'downPaymentPaid',
      'nextRoute',
      'bypassDocuments',
    ]),
  },
  methods: {
    handleNextStep() {
      this.$router.replace({
        name: this.nextRoute,
        query: this.$route.query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../styles/index.scss';
</style>
